import request from '@/router/axios'

const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/team/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const update = params => request({
  url: '/api/mcc-worker/team/update',
  method: 'post',
  data: params,
})

// 获取所用工长列表数据
export const getSupervisor = (current, size, params) => request({
  url: '/api/mcc-worker/team/teamLeaderList',
  method: 'get',
  params: {
    ...params,
    current: 1,
    size: -1,
  },
})

export default {
  getList,
  update,
}
